export enum BookmarkFilterEnum {
  onlyYou = "onlyYou",
  organization = "organization",
  default = "default",
}
